import {createAction} from "util/redux";
import {UrlParamsState} from 'module/UrlParam/reducer/UrlParamReducer'

const NAMESPACE = "UrlParams/"
export const urlParamSetAction = createAction<UrlParamsState>(NAMESPACE + "set");